import React from "react";
import family from "../../assets/home/family.png";

function IconWithText({ icon, text }) {
  return (
    <div className="flex gap-2 items-start leading-[162.5%] max-md:flex-wrap mt-5">
      <img
        loading="lazy"
        src={icon}
        alt="Bullet point icon"
        className="shrink-0 w-6 aspect-square"
      />
      <p className="max-w-[calc(100%-2rem)]">{text}</p>{" "}
      {/* Adjust max-width to leave space for gap */}
    </div>
  );
}

export default function About() {
  const iconTextData = [
    {
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/efbd10c4799084d6c26f208df8f42b2116025b662fe3413ae7474be7b747cae1?apiKey=407d704e01f2493092f36d784e4d9811&",
      text: "24-hour Caregiver and Nurse staffing to provide continuous support and supervision",
    },
    {
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/efbd10c4799084d6c26f208df8f42b2116025b662fe3413ae7474be7b747cae1?apiKey=407d704e01f2493092f36d784e4d9811&",
      text: "Skilled nursing care including tracheostomy, ventilator, PEG tube, and IV medication management",
    },
    {
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/efbd10c4799084d6c26f208df8f42b2116025b662fe3413ae7474be7b747cae1?apiKey=407d704e01f2493092f36d784e4d9811&",
      text: "Coordinated pharmacy services with medications delivered directly to the home",
    },
  ];

  return (
    <section className="container my-5">
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
        <div className="relative w-full lg:w-1/2 flex items-center justify-start transition-opacity duration-1000 lg:mr-0 lg:ml-0">
          <img
            loading="lazy"
            src={family}
            alt="Home Backround Image"
            className="object-cover w-full h-full min-h-[250px] filter opacity-100 rounded-none lg:rounded-l-xl lg:rounded-r-none lg:ml-0 lg:mr-0"
            style={{ objectPosition: 'left center' }}
          />
        </div>
        <div className="flex flex-col ml-5 w-[50%] max-md:ml-0 max-md:w-full transition-opacity duration-1000">
          <div className="flex flex-col self-stretch px-5 my-auto text-base text-zinc-500 max-md:mt-10 max-md:max-w-full">
            <h2 className="text-center text-5xl leading-[58px] text-zinc-800 font-bold max-md:max-w-full max-md:text-4xl max-md:leading-[54px]">              About Us
            </h2>
            <p className="mt-4 text-lg leading-7 max-md:max-w-full">
              Welcome to <b>Angel Haven by the Creek</b>, a licensed Adult Family Home where compassionate care meets clinical excellence. We provide a safe, nurturing environment for adults who need extended care, with a focus on dignity, comfort, and individual well-being.
            </p>
            <p className="mt-4 text-lg leading-7 max-md:max-w-full">
              Our home is designed for residents who require both personal assistance and skilled nursing support, including high-acuity services under Private Duty Nursing (PDN). With a dedicated team of professionals and a strong commitment to quality, we ensure every resident receives the attention they deserve
            </p>
            <p className="mt-4"><b>Our Services Include:</b></p>
            <div>
              {iconTextData.map((item, index) => (
                <IconWithText key={index} icon={item.icon} text={item.text} />
              ))}
            </div>
            <p className="mt-4 text-lg leading-7 max-md:max-w-full">
              At Angel Haven by the Creek, our residents are more than clients—they are family. We invite you to discover the difference a compassionate, high-quality care setting can make.
            </p>
            <a href="/about">
              <button className="mx-auto text-center justify-center min-w-full py-4 mt-10 font-bold text-white bg-[linear-gradient(135deg,#7F9CF5_0%,#22D3EE_100%)] max-md:px-5 w-auto">
                Learn More
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
